import React from 'react';
import Grid from '@mui/material/Grid';
import CommonSDF from 'components/commonSDF/CommonSDF';
import { Box } from '@mui/material';

function CustomerBreadCrumb(props) {

  const breadcrumbPaths = [
  ];

  return (
    <div>
      <Grid
        container
        direction="row"
        justifyContent={{xs:'flex-start',sm:'flex-end',md:'flex-end',lg:'flex-end'}}
        sx={{ width: '100%' }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          sx={{ width: '100%' }}
        >
          <Box sx={{
            width: '100%',
            display: 'flex',
          }}>
            <CommonSDF
              onSearchQuery={props?.onSearch}
              search={props?.searchValue}
              defaultStatus={props?.defaultStatus}
              filterdata={props?.filterdata}
              onFilterChange={props?.onFilterChange}
              onRestFilter={props?.onRestFilter}
              tabName={props?.tabName}
              filter={props?.filter}
            />
          </Box>
        </Grid>
      </Grid>
    </div>
  );
}

export default CustomerBreadCrumb;

